// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type HelpFragment = { __typename?: "User"; id: string; demo: boolean };

export const HelpFragmentDoc = gql`
  fragment Help on User {
    id
    demo
  }
`;
